import { cn } from '@/lib/utils'

export type PaneListCountUnit = {
  singular: string
  plural: string
}

export type PaneListCountProps = {
  count: number
  unit: PaneListCountUnit
  /** Shown instead of the count line (e.g. loading). */
  loadingLabel?: string
  /** Extra segments joined with · after the count phrase. */
  meta?: string[]
  className?: string
}

export function formatPaneListCount({
  count,
  unit,
  meta,
}: {
  count: number
  unit: PaneListCountUnit
  meta?: string[]
}): string {
  const phrase = count === 1 ? `1 ${unit.singular}` : `${count} ${unit.plural}`
  if (!meta?.length) return phrase
  return `${phrase} · ${meta.join(' · ')}`
}

/** Count line above pane card grids — shared by browse lists and analysis results. */
export function PaneListCount({ count, unit, loadingLabel, meta, className }: PaneListCountProps) {
  if (loadingLabel) {
    return <p className={cn('text-sm text-muted-foreground', className)}>{loadingLabel}</p>
  }

  return (
    <p
      className={cn('text-sm tabular-nums text-muted-foreground', className)}
      aria-live="polite"
      aria-atomic="true"
    >
      {formatPaneListCount({ count, unit, meta })}
    </p>
  )
}
